export let texts = [
    {
        "id": "rest",
        "name":"Web Services",
        "title": "Web Services",
        "body": `
            With the new Web Service functionality you can load data from the internet to show in your
            prototype. You can also use the web services to send user data from your prototype to a web service
            and show the results.
        `,
        "video": {
            "src": "https://www.youtube.com/embed/9Ex8do5vWaY"
        }
    }
]